import { useEffect, useState } from "react";

const useViewportWidth = () => {
  const [viewportWidth, setViewportWidth] = useState<number>(0);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const updateWidth = () => {
      setViewportWidth(window.innerWidth);
    };

    window.addEventListener("resize", updateWidth);

    updateWidth();

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  return viewportWidth;
};

export default useViewportWidth;
